import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { SessionFlow } from './components/SessionFlow';

/** '/s/:linkToken' (SMS link) renders the same flow with the link join strategy. */
function LinkEntry(): JSX.Element {
  const { linkToken } = useParams<'linkToken'>();
  return <SessionFlow linkToken={linkToken} />;
}

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<SessionFlow />} />
      <Route path="/s/:linkToken" element={<LinkEntry />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
